export default __webpack_public_path__ + "static/refer_iphone_share-bf29ee61fa7dfa9838e46295dfc9a28a.webp";